import React, { Component, Fragment } from "react";

import ServiceClasses from "./ServicesOptions.module.css";
import axios from "axios";
import classes from "../../LandingPage/PostOption/PostOption.module.css";
import toggeList from "../../../assets/svg/toggeList.svg";
import { connect } from "react-redux";
import Map from "../../../Components/UI/Map/Map";
import * as actionCreator from "../../../Store/actions/index";

const CATEGORY = {
  1: "Body Shop",
  2: "Towing",
  3: "Wash",
  4: "Services / Repairs",
};

class ServicesOptions extends Component {
  state = {
    //Coordinate:
    coords: null,
    //################## TOGGLING STATE:
    showVideos: true,
    showImages: true,
    showTechnical: true,
    //################## VIDEO STATE:
    video: {
      vidEdited: false,
      editedVidSrc: null,
      editedVidSize: null,
      editedVidType: null,
    },
    //#################### IMAGES :
    baicsImgs: {
      imgOne: {
        imgEdited: false,
        editedImgSrc: null,
        name: "Image One",
        editName: "1",
      },
      // imgTow: {
      //     imgEdited: false,
      //     editedImgSrc: null,
      //     name: 'Image Tow',
      //     editName: '2'
      // },
      // imgThree: {
      //     imgEdited: false,
      //     editedImgSrc: null,
      //     name: 'Image Three',
      //     editName: '3'
      // },
      // imgFour: {
      //     imgEdited: false,
      //     editedImgSrc: null,
      //     name: 'Image Four',
      //     editName: '4'
      // },
      // imgFive: {
      //     imgEdited: false,
      //     editedImgSrc: null,
      //     name: 'Image Five',
      //     editName: '5'
      // },
      // imgSix: {
      //     imgEdited: false,
      //     editedImgSrc: null,
      //     name: 'Image Six',
      //     editName: '6'
      // }
    },
    optionalImg: {
      optionalImgOne: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "7",
      },
      optionalImgTow: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "8",
      },
      optionalImgThree: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "9",
      },
      optionalImgFour: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "10",
      },
      optionalImgFive: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "11",
      },
      optionalImgSix: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "12",
      },
    },
    // ############################## FIELDS VALUE :
    title: this.props.postToEdit ? this.props.postToEdit.title : "",
    sellerPitch: this.props.postToEdit
      ? this.props.postToEdit.seller_pitch
      : "",
    serviceCategory: this.props.postToEdit
      ? this.props.postToEdit.category_id
      : "",
    country_id: this.props.postToEdit ? this.props.postToEdit.country_id : "",
    state_id: this.props.postToEdit ? this.props.postToEdit.state_id : "",
    area_id: this.props.postToEdit ? this.props.postToEdit.area_id : "",

    // ############################### FETCHED ARRIES :

    countries: [],
    states: [],
    areas: [],
    filterdStates: [],
    filterdAreas: [],

    // Opening Hours:
    openingHours: [
      {
        day_name: "Monday",
        opening_time: "09:00",
        closing_time: "18:00",
      },
      {
        day_name: "Tuesday",
        opening_time: "09:00",
        closing_time: "18:00",
      },
      {
        day_name: "Wednesday",
        opening_time: "09:00",
        closing_time: "18:00",
      },
      {
        day_name: "Thursday",
        opening_time: "09:00",
        closing_time: "18:00",
      },
      {
        day_name: "Friday",
        opening_time: "09:00",
        closing_time: "18:00",
      },
      {
        day_name: "Saturday",
        opening_time: "",
        closing_time: "",
        close: true,
      },
      {
        day_name: "Sunday",
        opening_time: "",
        closing_time: "",
        close: true,
      },
    ],
  };

  componentDidMount() {
    this.fetchVihecleMakeModelVariant(this.props.vihecleType);
    if (this.props.postToEdit) {
      this.ExistedImagesHandler();
    }
  }

  // ############################################# FETCHED ARRIES METHODS :

  vehicleTypeFormater = (type) => {
    switch (type) {
      case "car":
        return (type = "cars");
      case "motor":
        return (type = "motors");
      case "commercial":
        return (type = "commercials");
      case "car_services":
        return (type = "cars");
      case "motors_services":
        return (type = "motors");
      case "commercial_services":
        return (type = "commercials");
      default:
        return type;
    }
  };

  fetchVihecleMakeModelVariant(type) {
    type = this.vehicleTypeFormater(type);
    if (type === "cars" || type === "motors" || type === "commercials") {
      axios
        .get(`countries`)
        .then((response) => {
          this.setState({
            countries: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`states`)
        .then((response) => {
          this.setState({
            states: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`areas`)
        .then((response) => {
          this.setState({
            areas: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  selectCountryChangedHandler = (name, value) => {
    let updatedStates = [...this.state.states];
    updatedStates = updatedStates.filter((state) => {
      return state.country_id === parseInt(value);
    });
    this.setState({
      filterdStates: updatedStates,
      filterdAreas: [],
      [`${name}`]: value,
    });
  };

  selectStatesChangedHandler = (name, value) => {
    let updatedAreas = [...this.state.areas];
    updatedAreas = updatedAreas.filter((area) => {
      return area.state_id === parseInt(value);
    });
    this.setState({
      filterdAreas: updatedAreas,
      [`${name}`]: value,
    });
  };

  selectAreasChangedHandler = (name, value) => {
    this.setState({
      [`${name}`]: value,
    });
  };

  //######################    Toggel SEctions:
  toggelShowSection = (event, showMode) => {
    const position = event.pageY;
    this.setState((prevState) => {
      return {
        [`${showMode}`]: !prevState[`${showMode}`],
      };
    });
    const timO = setTimeout(() => {
      // window.scrollTo(0, position + 800)
      window.scrollTo({
        top: position,
        left: 0,
        behavior: "smooth",
      });
      this.clearTimeOut(timO);
    }, 100);
  };

  clearTimeOut = (timO) => {
    clearTimeout(timO);
  };

  //################ upload viedeo :
  uploadVideoHnadler = (event) => {
    const name = event.target.name;
    const file = event.target.files.item(0);
    let reader = new FileReader();
    let base46Img = null;
    const ImgTypes = [
      "video/mp4",
      "video/mkv",
      "video/flv",
      "video/mov",
      "video/wmv",
      "video/avi",
      "video/avchd",
      "video/webm",
    ];
    const currentImgUpdate = { ...this.state[`${name}`] };
    const validType = ImgTypes.some((type) => {
      if (file) {
        return file.type === type;
      } else return null;
    });
    if (validType && file.size < 100 * 1000000) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        base46Img = reader.result;
        currentImgUpdate.vidEdited = true;
        currentImgUpdate.editedVidSrc = base46Img;
        currentImgUpdate.editedVidType = file;
        this.setState({ [`${name}`]: currentImgUpdate });
      };
    }
  };

  //################## image Handler
  uploadImageHandler = (event, optional) => {
    const currentImg = event.target.name;
    const file = event.target.files.item(0);
    let reader = new FileReader();
    let base46Img = null;
    const ImgTypes = ["image/jpeg", "image/png", "image/gif"];
    const validType = ImgTypes.some((type) => {
      if (file) {
        return file.type === type;
      } else return null;
    });
    let currentImgArray;
    if (!optional) {
      currentImgArray = { ...this.state.baicsImgs };
    } else {
      currentImgArray = { ...this.state.optionalImg };
    }
    const currentImgUpdate = { ...currentImgArray[`${event.target.name}`] };

    if (validType) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        base46Img = reader.result;
        currentImgUpdate.imgEdited = true;
        currentImgUpdate.editedImgSrc = base46Img;
        currentImgArray[`${currentImg}`] = currentImgUpdate;
        if (!optional) {
          this.setState({ baicsImgs: currentImgArray });
        } else {
          this.setState({ optionalImg: currentImgArray });
        }
      };
    }
  };

  //###############  Upload All
  stateImgFinder = (numb) => {
    switch (numb) {
      case 0:
        return "imgOne";
      case 1:
        return "imgTow";
      case 2:
        return "imgThree";
      case 3:
        return "imgFour";
      case 4:
        return "imgFive";
      case 5:
        return "imgSix";
      default:
        return null;
    }
  };

  uploadAllHAndler = (event) => {
    let files = event.target.files;
    const currentImgArray = { ...this.state.baicsImgs };
    for (let i = 0; i < files.length; i++) {
      if (i >= 6) {
        break;
      } else {
        let file = files[i];
        let reader = new FileReader();
        let base46Img = null;
        let stateImg = this.stateImgFinder(i);
        const ImgTypes = ["image/jpeg", "image/png", "image/gif"];
        const validType = ImgTypes.some((type) => {
          if (file) {
            return file.type === type;
          } else return null;
        });

        const currentImgUpdate = { ...currentImgArray[`${stateImg}`] };

        if (validType) {
          reader.readAsDataURL(file);
          reader.onload = () => {
            base46Img = reader.result;
            currentImgUpdate.imgEdited = true;
            currentImgUpdate.editedImgSrc = base46Img;
            currentImgArray[`${stateImg}`] = currentImgUpdate;
            this.setState({ baicsImgs: currentImgArray });
          };
        }
      }
    }
  };

  // ####################### Existed Images :
  nestedStateUpdater = (basic, editName, content) => {
    let updatedBasicImgs = null;
    if (basic) {
      updatedBasicImgs = { ...this.state.baicsImgs };
    } else {
      updatedBasicImgs = { ...this.state.optionalImg };
    }
    const key = Object.entries(updatedBasicImgs).filter((img) => {
      if (editName === img[1].editName) {
        return img;
      } else return null;
    })[0][0];
    const updateImg = { ...updatedBasicImgs[`${key}`] };
    updateImg.editedImgSrc = content;
    return [key, updateImg];
  };

  ExistedImagesHandler = () => {
    const updateImg = {},
      updateOpt = { ...this.state.optionalImg },
      updatedHours = [...this.state.openingHours];
    if (this.props.postToEdit) {
      this.props.postToEdit.media.forEach((mediaEle) => {
        if (mediaEle.name === "video") {
          const video = { ...this.state.video };
          video.editedVidSrc = mediaEle.url;
          this.setState({ video: video });
        } else if (+mediaEle.name < 7) {
          const [key, val] = this.nestedStateUpdater(
            true,
            mediaEle.name,
            mediaEle.url
          );
          updateImg[`${key}`] = val;
        } else if (+mediaEle.name > 6) {
          const [key, val] = this.nestedStateUpdater(
            false,
            mediaEle.name,
            mediaEle.url
          );
          updateOpt[`${key}`] = val;
        }
      });
      this.props.postToEdit.opening_hours.forEach((day, i) => {
        const updatedDay = { ...updatedHours[i] };
        updatedDay.day_name = day.day_name;
        updatedDay.opening_time = day.opening_time;
        updatedDay.closing_time = day.closing_time;

        if (
          updatedDay.day_name === "Saturday" ||
          updatedDay.day_name === "Sunday"
        ) {
          if (
            updatedDay.opening_time === null ||
            updatedDay.closing_time === null
          ) {
            updatedDay.opening_time = "";
            updatedDay.closing_time = "";
            updatedDay.close = true;
          } else {
            updatedDay.close = false;
          }
        }
        updatedHours[i] = updatedDay;
      });
      this.setState({
        baicsImgs: updateImg,
        optionalImg: updateOpt,
        openingHours: updatedHours,
      });
    }
  };

  // ################ Form Methods:

  setCoordinateHandler = (coords) => {
    this.setState({ coords: coords });
  };

  inputChangeHandler = (name, value) => {
    this.setState({
      [`${name}`]: value,
    });
  };

  changeTimeHandler = (event, closeing) => {
    let index = null;
    const name = event.target.name,
      value = event.target.value,
      updatedHours = [...this.state.openingHours],
      currentDay = updatedHours.filter((day, i) => {
        if (day.day_name === name) {
          index = i;
          return day;
        } else return null;
      })[0];
    if (closeing) {
      currentDay.closing_time = value;
    } else {
      currentDay.opening_time = value;
    }
    updatedHours[index] = currentDay;
    this.setState({ openingHours: updatedHours });
  };

  weekendHandler = (event) => {
    let index = null;
    const name = event.target.title,
      updatedHours = [...this.state.openingHours],
      currentDay = updatedHours.filter((day, i) => {
        if (day.day_name === name) {
          index = i;
          return day;
        } else return null;
      })[0];
    currentDay.close = !currentDay.close;
    if (currentDay.close) {
      currentDay.closing_time = "";
      currentDay.opening_time = "";
    } else {
      currentDay.closing_time = "18:00";
      currentDay.opening_time = "09:00";
    }
    updatedHours[index] = currentDay;
    this.setState({ openingHours: updatedHours });
  };

  formSubmitHandler = (event) => {
    event.preventDefault();
    const valuesArray = [];
    const errorArray = [];
    let openHoursError = "no error";
    valuesArray.push(
      { Category: this.state.serviceCategory },
      { Title: this.state.title },
      { "Seller Pitch": this.state.sellerPitch },
      { Country: this.state.country_id },
      { State: this.state.state_id },
      { Area: this.state.area_id }
    );
    Object.values(this.state.baicsImgs).forEach((img) => {
      valuesArray.push({
        [`${img.name}`]: img.editedImgSrc,
      });
    });
    this.state.openingHours.forEach((day) => {
      if ((!day.day_name === "Saturday") | (!day.day_name === "Sunday")) {
        if (day.closing_time.trim() === "" || day.opening_time.trim() === "") {
          openHoursError = "";
        }
      }
      // } else {

      // }
    });
    valuesArray.push({ "Opening Hours": openHoursError });
    valuesArray.map((ele) => {
      return Object.entries(ele).map((val) => {
        if (typeof val[1] === "string") {
          if (val[1].trim() === "") {
            errorArray.push(val[0]);
          }
        } else if (!val[1]) {
          errorArray.push(val[0]);
        }
        return errorArray;
      });
    });
    window.scrollTo(0, 0);
    const errorMess =
      "Please provid values for the following fields :\n" +
      errorArray.join("\n");
    if (errorArray.length > 0) {
      this.props.errorModalHandler(errorMess);
    } else {
      this.searchUrlConstructor();
    }
  };

  searchUrlConstructor = () => {
    const data = {
        category_id: this.state.serviceCategory,
        title: this.state.title,
        seller_pitch: this.state.sellerPitch,
        country_id: this.state.country_id,
        state_id: this.state.state_id,
        area_id: this.state.area_id,
        is_published: 0,
        ...this.state.coords,
      },
      opening_hours = [],
      mediaData = {},
      video = this.state.video.editedVidType,
      optionalStart = 7;
    let media = [],
      vidMedia = null;
    Object.values(this.state.baicsImgs).forEach((img, i) => {
      if (img.imgEdited) {
        media.push({
          name: i + 1,
          content: img.editedImgSrc,
        });
      }
    });
    Object.values(this.state.optionalImg).forEach((img, i) => {
      if (img.editedImgSrc && img.imgEdited) {
        media.push({
          name: optionalStart + i,
          content: img.editedImgSrc,
        });
      }
    });
    if (video) {
      if (this.state.video.vidEdited) {
        vidMedia = {
          name: "video",
          content: video,
        };
      }
      media.push(vidMedia);
    }
    this.state.openingHours.forEach((day, i) => {
      const newEl = { ...day };
      delete newEl.close;
      opening_hours.push(newEl);
    });
    data.opening_hours = opening_hours;
    if (this.props.postToEdit) {
      mediaData.media = media;
      const postId = localStorage.getItem("draftId");
      if (mediaData.media.length) {
        this.props.onSaveEditedPost(
          this.props.vihecleType,
          postId,
          data,
          mediaData,
          vidMedia
        );
      } else {
        this.props.onSaveEditedPost(
          this.props.vihecleType,
          postId,
          data,
          null,
          vidMedia
        );
      }
    } else {
      mediaData.media = media;
      this.props.onAddServiceToDraft(this.props.vihecleType, data, mediaData);
    }

    this.props.history.push("/Preview", { service: true });
  };

  // ######################## RENDER
  // ######################## RENDER
  // ######################## RENDER

  render() {
    const VideoWraperClasses = this.state.showVideos
      ? `${classes.VideoWraper}`
      : `${classes.Hide}`;

    const ImgWraperClasses = this.state.showImages
      ? `${classes.ImgWraper}`
      : `${classes.Hide}`;

    const formOptionsClasses = this.state.showTechnical
      ? `${classes.formOptions}`
      : `${classes.Hide}`;

    return (
      <div className={classes.SearchOptions}>
        {/*#################################################################################### VIDEOS */}
        <div
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection(event, "showVideos");
          }}
        >
          <h2 className="my-5">
            <img src={toggeList} alt="toggel" />
            Upload your service video
          </h2>
          <p className={classes.underTitle}>
            Listings with video is proven to sell faster
          </p>
        </div>
        <div className={VideoWraperClasses}>
          <div className={classes.ProfilePic}>
            <video
              controlsList="nodownload"
              controls
              src={this.state.video.editedVidSrc}
              height="200px"
            >
              Sorry, your browser doesn't support embedded videos.
            </video>
            <label>
              <input
                type="file"
                name="video"
                onChange={(event) => this.uploadVideoHnadler(event)}
              />
              Upload
            </label>
          </div>
        </div>
        {/*#################################################################################### IMAGES */}
        <div
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection(event, "showImages");
          }}
        >
          <h2 className="my-5">
            <img src={toggeList} alt="toggel" />
            Upload your service images{" "}
          </h2>
          <div className={ImgWraperClasses}>
            {/* <p className={classes.underTitle}>Add at least six images, services with informative images proven to sell faster</p>
                        <div className={classes.UploadAll}>
                        <p className={classes.underTitle}>Select Multiple picture altogether at once</p>
                            <label>
                                <input type="file" name="uploadAll" multiple onChange={event => this.uploadAllHAndler(event)} />
                                Bulk Upload
                            </label>
                        </div> */}
            {Object.entries(this.state.baicsImgs).map((img) => {
              let currentImg = null;
              if (img[1].editedImgSrc) {
                currentImg = <img src={img[1].editedImgSrc} alt="Service" />;
              }
              return (
                <div key={img[0]} className={classes.ProfilePic}>
                  {currentImg ? currentImg : <p>Serviec image</p>}
                  <label>
                    <input
                      type="file"
                      name={img[0]}
                      onChange={(event) => {
                        this.uploadImageHandler(event);
                      }}
                    />
                    Upload
                  </label>
                </div>
              );
            })}
            {Object.entries(this.state.optionalImg).map((img) => {
              let currentImg = null;
              if (img[1].editedImgSrc) {
                currentImg = <img src={img[1].editedImgSrc} alt="Service" />;
              }
              return (
                <div key={img[0]} className={classes.ProfilePic}>
                  {currentImg ? currentImg : <p>Optional serviec image</p>}
                  <label>
                    <input
                      type="file"
                      name={img[0]}
                      onChange={(event) => {
                        this.uploadImageHandler(event, true);
                      }}
                    />
                    Upload
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <div
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection(event, "showTechnical");
          }}
        >
          <h2 className="my-5">
            <img src={toggeList} alt="toggel" />
            Serviec informaition
          </h2>
        </div>

        {/*################################################## form Option */}
        {/*################################################## form Option */}
        {/*################################################## form Option */}

        <div className={formOptionsClasses}>
          <form
            onSubmit={(event) => {
              this.formSubmitHandler(event);
            }}
          >
            <p className="mt-3">Categories</p>
            <div className={classes.VehicleTypes}>
              {Object.entries(CATEGORY).map((category) => {
                return (
                  <Fragment key={category[0]}>
                    <input
                      value={`${category[0]}`}
                      type="radio"
                      name="serviceCategory"
                      id={`${category[0]}`}
                      defaultChecked={
                        this.props.postToEdit
                          ? this.props.postToEdit.category_id === +category[0]
                            ? true
                            : false
                          : false
                      }
                      onChange={(event) => {
                        this.inputChangeHandler(
                          event.target.name,
                          event.target.value
                        );
                      }}
                    />
                    <label htmlFor={`${category[0]}`}>{category[1]}</label>
                  </Fragment>
                );
              })}
            </div>
            <div className={classes.SearchNinputElementWraper}>
              <p className="mt-3">Title</p>
              <input
                ref={this.optionRef}
                className={classes.textInput}
                type="text"
                placeholder="Title"
                value={this.state.title}
                onChange={(event) => {
                  this.setState({
                    title: event.target.value,
                  });
                }}
              />
            </div>
            <p className="mt-3">Seller Pitch</p>
            <textarea
              // className={classes.textInput}
              placeholder="seller Pitch"
              value={this.state.sellerPitch}
              onChange={(event) => {
                this.setState({
                  sellerPitch: event.target.value,
                });
              }}
            />
            <p className="mt-3">Openin Hours </p>
            <div className={ServiceClasses.OpeningWraper}>
              {this.state.openingHours.map((day, i) => {
                let classStyle = ServiceClasses.DaysWraper;
                if (i % 2 === 0) {
                  classStyle = `${ServiceClasses.DaysWraper} ${ServiceClasses.DaysBackground}`;
                }
                return (
                  <div key={day.day_name} className={classStyle}>
                    <p className={ServiceClasses.DayName+" mb-0"}>
                      {day.day_name}
                      {day.day_name === "Saturday" ||
                      day.day_name === "Sunday" ? (
                        <small
                          title={day.day_name}
                          className={
                            day.close
                              ? ServiceClasses.Close
                              : ServiceClasses.Open
                          }
                          onClick={(event) => this.weekendHandler(event)}
                        >
                          {day.close ? "Close" : "Open"}
                        </small>
                      ) : null}
                    </p>
                    <div className={ServiceClasses.DaysWraper}>
                      <p className="mb-0">Open</p>
                      <input
                        name={day.day_name}
                        type="time"
                        value={day.opening_time}
                        onChange={(event) => {
                          if (!day.close) this.changeTimeHandler(event);
                        }}
                      />
                    </div>
                    <div className={ServiceClasses.DaysWraper}>
                      <p className="mb-0">Close</p>
                      <input
                        name={day.day_name}
                        type="time"
                        value={day.closing_time}
                        onChange={(event) => {
                          if (!day.close) this.changeTimeHandler(event, true);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className={classes.SearchNinputElementWraper}>
              <p className="mt-3">Country</p>
              <select
                name="country_id"
                onChange={(event) => {
                  this.selectCountryChangedHandler(
                    event.target.name,
                    event.target.value
                  );
                }}
              >
                <option
                  value={
                    this.props.postToEdit
                      ? this.props.postToEdit.country.id
                      : ""
                  }
                >
                  {this.props.postToEdit
                    ? this.props.postToEdit.country.name
                    : "Country"}
                </option>
                {this.state.countries.map((option) => {
                  return (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className={classes.SearchNinputElementWraper}>
              <p className="mt-3">State</p>
              <select
                name="state_id"
                onChange={(event) => {
                  this.selectStatesChangedHandler(
                    event.target.name,
                    event.target.value
                  );
                }}
              >
                <option
                  value={
                    this.props.postToEdit ? this.props.postToEdit.state.id : ""
                  }
                >
                  {this.props.postToEdit
                    ? this.props.postToEdit.state.name
                    : "State"}
                </option>
                {this.state.filterdStates.map((option) => {
                  return (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className={classes.SearchNinputElementWraper}>
              <p className="mt-3">Area</p>
              <select
                name="area_id"
                onChange={(event) => {
                  this.selectAreasChangedHandler(
                    event.target.name,
                    event.target.value
                  );
                }}
              >
                <option
                  value={
                    this.props.postToEdit ? this.props.postToEdit.area.id : ""
                  }
                >
                  {this.props.postToEdit
                    ? this.props.postToEdit.area.name
                    : "Area"}
                </option>
                {this.state.filterdAreas.map((option) => {
                  return (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <Map
              setCoordinate={this.setCoordinateHandler}
              coords={
                this.props.postToEdit
                  ? {
                      lat: this.props.postToEdit.lat,
                      lng: this.props.postToEdit.lng,
                    }
                  : null
              }
            />
            <div className={classes.Controls}>
              <button
                type="submit"
                className={`${classes.Btn} ${ServiceClasses.Btn}`}
              >
                Preview Post
              </button>
              {this.props.postToEdit && this.props.postMode && (
                <button
                  type="button"
                  className={`${classes.Btn} ${classes.Rest}`}
                  onClick={(event) => {
                    this.props.history.push("/Activites");
                    this.props.onDeleteActivityPost(this.props.postToEdit.id);
                  }}
                >
                  Delete
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    postingService: state.AddService.postingService,
    draftService: state.AddService.draftService,
    draftServiceId: state.AddService.draftServiceId,
    darfServiceError: state.AddService.darfServiceError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddServiceToDraft: (serviceType, data, mediaData) => {
      dispatch(actionCreator.sendServiceAsDraft(serviceType, data, mediaData));
    },
    onSaveEditedPost: (vType, postId, data, media, vidMedia) => {
      dispatch(actionCreator.putEditPost(vType, postId, data, media, vidMedia));
    },
    onDeleteActivityPost: (id) => {
      dispatch(actionCreator.deleteAcitivityPost(id));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ServicesOptions);
